import React from 'react';
import styled from '@emotion/styled';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import Icon, { iconNames } from '../icons';
import { BREAKPOINTS, COLORS, FONT_SIZE, FONT_WEIGHT, GLOBAL, SPACE } from '../../constants';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'className' implicitly has an 'any' type.
const ExpandIcon = ({ className, onClick }) => (
  <IconButton className={className} onClick={onClick} size="medium">
    <Icon name={iconNames.expand} />
  </IconButton>
);

const StyledExpandButton = styled(ExpandIcon)`
  pointer-events: none;
  height: 4.5rem;
  /* TODO: wire up rotation */
  transform: ${
    /* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'isOpen' does not exist on type '{ className: any; onClick: any; } & { theme?: Theme | undefined; } & { theme: Theme; }'. */
    (props) => (props.isOpen ? `rotate(180deg)` : `rotate(0deg)`)
  };
  position: absolute !important;
  right: 0.5rem;

  @media (min-width: ${BREAKPOINTS.MD}px) {
    height: 3.5rem;
  }

  @media (min-width: ${BREAKPOINTS.LG}px) {
    height: 3rem;
  }

  @media (min-width: ${BREAKPOINTS.XL}px) {
    height: 2.25rem;
  }
`;

const StyledFormControl = styled(FormControl)`
  &.MuiFormControl-root {
    margin-bottom: ${SPACE.X2};
    margin-right: ${(props) => !props.fullWidth && SPACE.X1};
    * {
      font-family: ${GLOBAL.BRAND_FONT_FAMILY};
    }
  }
  & label + .MuiInput-formControl {
    margin-top: 0;
  }
`;

const StyledInputLabel = styled(InputLabel)`
  &.MuiInputLabel-formControl {
    color: ${COLORS.GREY_ELEVEN};
    font-family: ${GLOBAL.BASE_FONT_FAMILY};
    font-size: ${FONT_SIZE.X_LARGE};
    font-weight: ${FONT_WEIGHT.BOLD};
    line-height: ${FONT_SIZE.XX_LARGE};
    margin-bottom: ${SPACE.X0};
    position: static;
    transform: none;
  }
  &.MuiInputLabel-formControl.Mui-focused {
    color: unset;
  }
`;

const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  &.MuiToggleButtonGroup-root {
    gap: ${SPACE.X0};
    flex-wrap: wrap;
  }
`;

const StyledToggleButton = styled(ToggleButton)`
  &.MuiToggleButton-root {
    border: 1px solid ${COLORS.GREY_SIX};
    border-radius: 0;
    color: ${COLORS.BLACK};
    font-size: ${FONT_SIZE.MEDIUM};
    text-transform: none;
    outline: none;
    outline-offset: 3px;
    padding: 16px;
    line-height: 16px;
    margin: 0;

    @media (min-width: ${BREAKPOINTS.MD}px) {
      border: 1px solid ${COLORS.GREY_SIX};
      min-width: 200px;
    }

    &.Mui-focusVisible {
      outline: 2px solid ${COLORS.BRAND_BLUE_EIGHT};
    }

    &.Mui-selected {
      border: 2px solid ${COLORS.BRAND_BLUE_NINE};
      color: ${COLORS.BRAND_BLUE_NINE};
      background-color: ${COLORS.WHITE};
    }
  }
`;

const StyledSelect = {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'styles' implicitly has an 'any' type.
  container: (styles) => ({
    ...styles,
    backgroundColor: `${COLORS.WHITE}`,
    border: `1px solid ${COLORS.BLACK}`,
  }),

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'styles' implicitly has an 'any' type.
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: isFocused ? `${COLORS.WHITE}` : 'transparent',
    outlineOffset: '3px',
    outline: `2px solid ${isFocused ? COLORS.BRAND_BLUE_SIX : 'transparent'}`,
    border: `1px solid ${isFocused ? COLORS.BLACK : 'transparent'}`,
    borderRadius: '0',
    fontFamily: `${GLOBAL.BRAND_FONT_FAMILY_SECOND}`,
    fontSize: FONT_SIZE.X_LARGE,
    padding: '0.25rem',
    wordBreak: 'normal',
    whiteSpace: 'normal',
    [`@media (min-width: ${BREAKPOINTS.LG}px)`]: {
      padding: '0.25rem',
    },
    [`@media (min-width: ${BREAKPOINTS.XL}px)`]: {
      padding: `${SPACE.X0}`,
    },
  }),

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'styles' implicitly has an 'any' type.
  menu: (styles) => ({
    ...styles,
    fontFamily: `${GLOBAL.BRAND_FONT_FAMILY_SECOND}`,
    fontSize: `${FONT_SIZE.X_LARGE}`,
  }),

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'styles' implicitly has an 'any' type.
  menuList: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? `${COLORS.BRAND_BLUE_TWO}` : isFocused ? `${COLORS.BRAND_YELLOW_TEN}` : undefined,
  }),

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'styles' implicitly has an 'any' type.
  option: (styles, { isFocused }) => ({
    ...styles,
    color: `${COLORS.BLACK}`,
    backgroundColor: isFocused ? `${COLORS.BRAND_BLUE_THREE}` : 'transparent',
    ':hover': { backgroundColor: `${COLORS.BRAND_BLUE_FOUR}` },
    ':focus': { backgroundColor: `${COLORS.BRAND_BLUE_FOUR}` },
    ':active': { backgroundColor: `${COLORS.BRAND_BLUE_THREE}` },
  }),

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'styles' implicitly has an 'any' type.
  dropdownIndicator: (styles) => ({
    ...styles,
    paddingRight: '10px',
  }),

  indicatorSeparator: () => ({ display: 'none' }),
};

export {
  StyledExpandButton,
  StyledFormControl,
  StyledInputLabel,
  StyledSelect,
  StyledToggleButton,
  StyledToggleButtonGroup,
};
